export default "__VITE_ASSET__0mt3bjY2__"